// Generated from packages/workflow-builder/iconConverter.js
import { SvgIconProps, createSvgIcon } from '@automata/mui-theme';
import { BrokenImageOutlined as BrokenImageOutlinedIcon } from '@automata/mui-theme/icons';
import { logger } from '@automata/utils';
import { memo } from 'react';

import { AddLidIcon } from './AddLidIcon';
import { AspirateIcon } from './AspirateIcon';
import { CapIcon } from './CapIcon';
import { ConditionIcon } from './ConditionIcon';
import { CountIcon } from './CountIcon';
import { DispenseIcon } from './DispenseIcon';
import { DisposeIcon } from './DisposeIcon';
import { FreezeIcon } from './FreezeIcon';
import { IncubateIcon } from './IncubateIcon';
import { ManualInterventionIcon } from './ManualInterventionIcon';
import { PeelIcon } from './PeelIcon';
import { PickUpCapsIcon } from './PickUpCapsIcon';
import { PlaceholderIcon } from './PlaceholderIcon';
import { PrimeIcon } from './PrimeIcon';
import { PrintLabelIcon } from './PrintLabelIcon';
import { ProcessDataIcon } from './ProcessDataIcon';
import { ReadBarcodeIcon } from './ReadBarcodeIcon';
import { ReadIcon } from './ReadIcon';
import { ReleaseCapsIcon } from './ReleaseCapsIcon';
import { RemovedLidIcon } from './RemovedLidIcon';
import { RunIcon } from './RunIcon';
import { RunLiquidHandlerIcon } from './RunLiquidHandlerIcon';
import { ScanBarcodeIcon } from './ScanBarcodeIcon';
import { SealIcon } from './SealIcon';
import { ShakeIcon } from './ShakeIcon';
import { SpinCentrifugeIcon } from './SpinCentrifugeIcon';
import { SpinIcon } from './SpinIcon';
import { StoreIcon } from './StoreIcon';
import { UncapIcon } from './UncapIcon';
import { WashIcon } from './WashIcon';

export {
  AddLidIcon,
  AspirateIcon,
  CapIcon,
  CountIcon,
  DispenseIcon,
  DisposeIcon,
  FreezeIcon,
  IncubateIcon,
  ManualInterventionIcon,
  PeelIcon,
  PickUpCapsIcon,
  PlaceholderIcon,
  PrimeIcon,
  PrintLabelIcon,
  ReadIcon,
  ReadBarcodeIcon,
  ReleaseCapsIcon,
  RemovedLidIcon,
  RunIcon,
  RunLiquidHandlerIcon,
  ScanBarcodeIcon,
  SealIcon,
  ShakeIcon,
  SpinIcon,
  SpinCentrifugeIcon,
  StoreIcon,
  UncapIcon,
  WashIcon,
  ProcessDataIcon,
  ConditionIcon,
};

export const getIcon = (iconName: string): ReturnType<typeof createSvgIcon> => {
  switch (iconName) {
    case 'addlid':
      return AddLidIcon;
    case 'aspirate':
      return AspirateIcon;
    case 'cap':
      return CapIcon;
    case 'count':
      return CountIcon;
    case 'dispense':
      return DispenseIcon;
    case 'dispose':
      return DisposeIcon;
    case 'freeze':
      return FreezeIcon;
    case 'incubate':
      return IncubateIcon;
    case 'manualintervention':
      return ManualInterventionIcon;
    case 'peel':
      return PeelIcon;
    case 'pickupcaps':
      return PickUpCapsIcon;
    case 'placeholder':
      return PlaceholderIcon;
    case 'prime':
      return PrimeIcon;
    case 'printlabel':
      return PrintLabelIcon;
    case 'read':
      return ReadIcon;
    case 'readbarcode':
      return ReadBarcodeIcon;
    case 'releasecaps':
      return ReleaseCapsIcon;
    case 'removedlid':
      return RemovedLidIcon;
    case 'run':
      return RunIcon;
    case 'runliquidhandler':
      return RunLiquidHandlerIcon;
    case 'scanbarcode':
      return ScanBarcodeIcon;
    case 'seal':
      return SealIcon;
    case 'shake':
    case 'startshake':
    case 'stopshake':
      return ShakeIcon;
    case 'spin':
      return SpinIcon;
    case 'spincentrifuge':
      return SpinCentrifugeIcon;
    case 'store':
      return StoreIcon;
    case 'uncap':
      return UncapIcon;
    case 'wash':
      return WashIcon;
    case 'processdata':
      return ProcessDataIcon;
    case 'condition':
      return ConditionIcon;
    default:
      logger.log(`no icon for iconName ${iconName}`);
      return BrokenImageOutlinedIcon;
  }
};

export const Icon = memo(function Memoized({
  iconType,
  ...otherProps
}: SvgIconProps & { iconType: string }) {
  const Icon = getIcon(iconType.replace(/[-_]/g, ''));
  return <Icon style={{ fill: 'currentColor' }} {...otherProps} />;
});
